import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import "emun.salesrep/territory-manager/division/picker/division-picker-table.htm";
import DivisionParser from "emun.salesrep/territory-manager/division/parser/division-parser";

//export const filters = customerConfig.filters;

export const views = {
	list: "table",
	//  cards: "th-large"
};

export default class DivisionPickerController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.selected = {};
		Object.assign($ctrl, options);
		$ctrl.setDivisionIds();
		$ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
		$ctrl.bus = $ctrl.query.bus;
		//$ctrl.viewSelectionsChanged(); //load()
	}

	templateUrl = () => `division-picker-${this.query.view}.htm`;

	selectAll() {
		const $ctrl = this;
		$ctrl.query.results.forEach(p => ($ctrl.selected[p.id] = true));
		this.setDivisionIds();
	}
	clearAll() {
		this.selected = {};
		this.setDivisionIds();
	}
	canClear() {
		return Object.keys(this.selected).length;
	}

	isSelected(division) {
		return !!this.selected[division.id];
	}

	setDivisionIds() {
		this.divisionIds = Object.keys(this.selected || {});
	}

	selectionsLabel() {
		const { divisionIds: keys = [] } = this;
		if (keys.length > 4)
			return `Selected: ${keys.slice(0, 4).join(", ")} and ${keys.length -
				4} more...`;
		if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
		return "No selections";
	}

	hasSelections = () => Object.keys(this.selected).length > 0;

	viewSelectionsChanged() {
		const $ctrl = this;
		const idIn = $ctrl.viewSelections
			? Object.keys($ctrl.selected || {}).join(",")
			: null;
		$ctrl.query.clearRefinements(false);
		$ctrl.query.filter("IdIn", idIn);
	}

	toggle(division) {
		const $ctrl = this;
		console.log("toggle", division.id, $ctrl.selected, division);

		if ($ctrl.single) {
			$ctrl.$close(division);
		} else if (division.id in $ctrl.selected) {
			delete $ctrl.selected[division.id];
			$ctrl.onDivisionUnSelected &&
				$ctrl.onDivisionUnSelected({ $division: division, ...$ctrl });
		} else {
			$ctrl.selected[division.id] = true;
			$ctrl.onDivisionSelected &&
				$ctrl.onDivisionSelected({ $division: division, ...$ctrl });
		}
		this.setDivisionIds();
	}
	select(division) {
		const $ctrl = this;
		$ctrl.$close([division]);
	}

	$onDestroy() {
		this.query.dispose();
	}

	parseDivisions() {
		const $ctrl = this;
		DivisionParser({}).then(divisionIds => {
			$ctrl.selected = {};
			divisionIds.forEach(divisionId => {
				$ctrl.toggle({ id: divisionId });
			});
			$ctrl.viewSelections = true;
			$ctrl.viewSelectionsChanged();
		});
	}

	getAutoQueryOptions() {
		const $ctrl = this;
		return {
			url: "QueryDivisions.json",
			pageSize: $ctrl.$pageConfig.is("gt-sm") ? 12 : 6,
			views,
			criteria: $ctrl.criteria,
			view: "table",
//			filters,
			sortOptions: {
				'Name': 'Name: A to Z',
				'-Name': 'Name: Z to A',
			},
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			orderBy: "Name,Id",
			autoLoad: true,
			append: false
		};
	}
}


